var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoteSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 484.72,
    height: 460.919,
    viewBox: "0 0 484.72 460.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10698",
    "data-name": "Group 10698",
    transform: "translate(-717.64 -636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-54",
    transform: "translate(710 603.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5931",
    "data-name": "Path 5931",
    d: "M458.58,297.72l-7.81-4.51s-4.65-19.33-2.8-36.71c2.61-24.45,18.7-33.65,24.82-31.54s7.89,9.22-2.24,23.78C464.58,257.33,457.24,275.22,458.58,297.72Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10696",
    "data-name": "Group 10696",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    d: "M458.58,297.72l-7.81-4.51s-4.65-19.33-2.8-36.71c2.61-24.45,18.7-33.65,24.82-31.54s7.89,9.22-2.24,23.78C464.58,257.33,457.24,275.22,458.58,297.72Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5933",
    "data-name": "Path 5933",
    d: "M455.34,288.23h.08a.54.54,0,0,0,.43-.63c-4.28-22.55,3.59-47.89,13.35-58.43a.541.541,0,0,0-.8-.73c-9.93,10.73-18,36.48-13.61,59.36a.54.54,0,0,0,.55.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5934",
    "data-name": "Path 5934",
    d: "M478.25,309.07c1.16.6,4.27-2.06,5.13-2.7a10.871,10.871,0,0,0,3.39-4.32,10.09,10.09,0,0,0,.6-6.14,23.922,23.922,0,0,0-.94-3.2c-.35-1-.7-2.06-1.06-3.1a8,8,0,0,1-.62-3.15c.17-2.16,2-3.76,3.67-5.15,1.85-1.54,3.75-3.53,3.61-6.12a9.13,9.13,0,0,0-2.56-5.31c-1.31-1.5-2.85-2.82-4.06-4.41a6.39,6.39,0,0,1-1.5-4,6.63,6.63,0,0,1,.75-2.56,35.752,35.752,0,0,0,2.5-5.18c.53-1.84.33-4.09-1.15-5.32a6,6,0,0,0-4.51-.88,10.28,10.28,0,0,0-4.07,1.67c-4,2.49-6.1,7.48-10.37,9.46a44,44,0,0,1-5.21,1.55,6.57,6.57,0,0,0-4.21,3.2c-1.44,3.28,1.73,7.08.78,10.53-.85,3-3.71,4.35-5.21,7.14a6.45,6.45,0,0,0-.57,4,18.789,18.789,0,0,0,2,6.56,60.219,60.219,0,0,0,3.95,6.07S478.07,309,478.25,309.07Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10697",
    "data-name": "Group 10697",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    d: "M478.25,309.07c1.16.6,4.27-2.06,5.13-2.7a10.871,10.871,0,0,0,3.39-4.32,10.09,10.09,0,0,0,.6-6.14,23.922,23.922,0,0,0-.94-3.2c-.35-1-.7-2.06-1.06-3.1a8,8,0,0,1-.62-3.15c.17-2.16,2-3.76,3.67-5.15,1.85-1.54,3.75-3.53,3.61-6.12a9.13,9.13,0,0,0-2.56-5.31c-1.31-1.5-2.85-2.82-4.06-4.41a6.39,6.39,0,0,1-1.5-4,6.63,6.63,0,0,1,.75-2.56,35.752,35.752,0,0,0,2.5-5.18c.53-1.84.33-4.09-1.15-5.32a6,6,0,0,0-4.51-.88,10.28,10.28,0,0,0-4.07,1.67c-4,2.49-6.1,7.48-10.37,9.46a44,44,0,0,1-5.21,1.55,6.57,6.57,0,0,0-4.21,3.2c-1.44,3.28,1.73,7.08.78,10.53-.85,3-3.71,4.35-5.21,7.14a6.45,6.45,0,0,0-.57,4,18.789,18.789,0,0,0,2,6.56,60.219,60.219,0,0,0,3.95,6.07S478.07,309,478.25,309.07Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5936",
    "data-name": "Path 5936",
    d: "M466.94,303.18h0a.52.52,0,0,0,.47-.56c-1.87-20.28,6.57-43.2,13.21-50.07a.513.513,0,1,0-.74-.71c-6.77,7-15.39,30.31-13.49,50.87a.51.51,0,0,0,.55.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5937",
    "data-name": "Path 5937",
    d: "M469,278.18h.15A69.57,69.57,0,0,1,483.73,275a.5.5,0,0,0,.46-.55.49.49,0,0,0-.56-.47,70.408,70.408,0,0,0-14.88,3.18.52.52,0,0,0,.2,1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-54",
    cx: 242.36,
    cy: 139.93,
    rx: 242.36,
    ry: 139.93,
    transform: "translate(717.64 817.059)",
    fill: "#f0efef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-54",
    d: "M194.2,377.75l69.13-39.91-85.4-49.3L108.8,328.45Z",
    transform: "translate(710 603.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-54-2",
    "data-name": "freepik--shadow--inject-54",
    d: "M293.26,464.72l64.33-37.14-64.33-37.14-64.32,37.14Z",
    transform: "translate(710 603.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-54-3",
    "data-name": "freepik--shadow--inject-54",
    cx: 56.12,
    cy: 32.4,
    rx: 56.12,
    ry: 32.4,
    transform: "translate(1045.29 949.699)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M478.91,93.17,459.26,81.82a.67.67,0,0,1-.35-.59V58.37a.69.69,0,0,1,.34-.6.66.66,0,0,1,.69,0L479.6,69.12a.68.68,0,0,1,.35.6V92.57a.68.68,0,0,1-.35.6.67.67,0,0,1-.34.09.73.73,0,0,1-.35-.09ZM460.29,59.56V80.83l18.28,10.55V70.11Z",
    transform: "translate(710 603.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5943",
    "data-name": "Path 5943",
    d: "M478.91,132l-19.65-11.34a.69.69,0,0,1-.35-.6V97.21a.69.69,0,0,1,.34-.6.71.71,0,0,1,.69,0L479.6,108a.68.68,0,0,1,.35.6v22.86a.67.67,0,0,1-.35.59.59.59,0,0,1-.34.1.64.64,0,0,1-.35-.15ZM460.29,98.4v21.27l18.28,10.55V109Z",
    transform: "translate(710 603.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5944",
    "data-name": "Path 5944",
    d: "M478.91,170.86l-19.65-11.35a.68.68,0,0,1-.35-.6V136.05a.69.69,0,0,1,1-.6L479.6,146.8a.69.69,0,0,1,.35.6v22.86a.7.7,0,0,1-.35.6.67.67,0,0,1-.34.09.73.73,0,0,1-.35-.09Zm-18.62-33.61v21.26l18.28,10.55V147.8Z",
    transform: "translate(710 603.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    "data-name": "Path 5945",
    d: "M468.5,158.87l-4.57-9.68,2.11-2.02,3.05,6.5,10.68-10.3,1.53,3.19Z",
    transform: "translate(710 603.469)",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    "data-name": "Path 5946",
    d: "M198.15,68,178.49,56.67a.68.68,0,0,1-.34-.59V33.22a.7.7,0,0,1,.35-.6.71.71,0,0,1,.69,0L198.84,44a.69.69,0,0,1,.34.6V67.42a.69.69,0,0,1-.34.6.74.74,0,0,1-.35.1.7.7,0,0,1-.34-.12ZM179.53,34.41V55.68L197.8,66.23V45Z",
    transform: "translate(710 603.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5947",
    "data-name": "Path 5947",
    d: "M188.35,57.33l-4.57-9.68,2.11-2.02,3.05,6.5,10.68-10.3,1.53,3.19Z",
    transform: "translate(710 603.469)",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5948",
    "data-name": "Path 5948",
    d: "M228.63,85.61,209,74.26a.67.67,0,0,1-.35-.59V50.81a.69.69,0,0,1,.34-.6.71.71,0,0,1,.69,0l19.66,11.35a.68.68,0,0,1,.35.6V85a.72.72,0,0,1-.69.7.74.74,0,0,1-.37-.09ZM210,52V73.27l18.28,10.55V62.55Z",
    transform: "translate(710 603.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5949",
    "data-name": "Path 5949",
    d: "M259.08,103.2,239.43,91.86a.69.69,0,0,1-.35-.6V68.4a.69.69,0,0,1,.34-.6.71.71,0,0,1,.69,0l19.66,11.35a.68.68,0,0,1,.35.6v22.86a.67.67,0,0,1-.35.59.61.61,0,0,1-.34.1.64.64,0,0,1-.35-.1ZM240.46,69.59V90.86l18.28,10.55V80.15Z",
    transform: "translate(710 603.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cabin--inject-54",
    transform: "translate(710 603.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stand--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5950",
    "data-name": "Path 5950",
    d: "M181.23,161.39,126,324.95l-3.95,2.28,55.24-163.56Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5951",
    "data-name": "Path 5951",
    d: "M122.05,327.23l-1.95-1.12,55.23-163.57,1.96,1.13Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5952",
    "data-name": "Path 5952",
    d: "M177.29,295.34l-1.96-1.12L120.1,194.44l1.95,1.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5953",
    "data-name": "Path 5953",
    d: "M126,193.28l55.23,99.78-3.94,2.28-55.24-99.78Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5954",
    "data-name": "Path 5954",
    d: "M195.06,233.16v4.56l59.18-34.17V199Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5955",
    "data-name": "Path 5955",
    d: "M195.06,233.16v4.56L120.1,194.44v-4.56Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5956",
    "data-name": "Path 5956",
    d: "M254.24,203.55,199.01,367.12l-3.95,2.27L250.3,205.83Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5957",
    "data-name": "Path 5957",
    d: "M195.06,369.39l-1.95-1.12L248.34,204.7l1.96,1.13Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5958",
    "data-name": "Path 5958",
    d: "M250.3,337.5l-1.96-1.12L193.11,236.6l1.95,1.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5959",
    "data-name": "Path 5959",
    d: "M199.01,235.44l55.23,99.78-3.94,2.28-55.24-99.78Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cabin--inject-54-2",
    "data-name": "freepik--cabin--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5960",
    "data-name": "Path 5960",
    d: "M179.28,73.71l-15.8,9.12A86.77,86.77,0,0,0,120.1,158v31.91l3.94,2.28L183.22,158V76Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5961",
    "data-name": "Path 5961",
    d: "M179.28,73.71l-15.8,9.12A86.77,86.77,0,0,0,120.1,158v31.91l3.94,2.28L183.22,158V76Z",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5962",
    "data-name": "Path 5962",
    d: "M126.51,125.25,183.22,158h0V76l-3.94-2.28-15.8,9.12a86.73,86.73,0,0,0-36.97,42.41Z",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5963",
    "data-name": "Path 5963",
    d: "M124,192.16V160.25a86.759,86.759,0,0,1,43.388-75.139L183.22,76v82Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5964",
    "data-name": "Path 5964",
    d: "M124,192.16V160.25a86.759,86.759,0,0,1,43.388-75.139L183.22,76v82Z",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5965",
    "data-name": "Path 5965",
    d: "M191.12,226.33,124.04,187.6l59.18-34.16,67.08,38.72Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5966",
    "data-name": "Path 5966",
    d: "M191.12,226.33,124.04,187.6l59.18-34.16,67.08,38.72Z",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5967",
    "data-name": "Path 5967",
    d: "M191.12,230.89v-4.56L124.04,187.6v4.56Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5968",
    "data-name": "Path 5968",
    d: "M191.12,230.89v-4.56L124.04,187.6v4.56Z",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5969",
    "data-name": "Path 5969",
    d: "M146.3,189.47l27.62,15.95,35.51-20.5-27.62-15.95Z",
    fill: "#fd0113",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5970",
    "data-name": "Path 5970",
    d: "M146.3,187.85l27.62,15.94,35.51-20.5-27.62-15.94Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5971",
    "data-name": "Path 5971",
    d: "M193.64,188.09a.27.27,0,0,1-.12,0l-3.94-2.28a.24.24,0,0,1,0-.42l3.94-2.28a.25.25,0,0,1,.24,0l4,2.28a.24.24,0,0,1,0,.42l-4,2.28a.24.24,0,0,1-.12,0Zm-3.46-2.52,3.46,2,3.46-2-3.46-2Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5972",
    "data-name": "Path 5972",
    d: "M185.75,192.65h-.12l-3.94-2.28a.26.26,0,0,1-.13-.21.23.23,0,0,1,.13-.21l3.94-2.28a.21.21,0,0,1,.24,0l3.95,2.28a.24.24,0,0,1,.12.21.27.27,0,0,1-.12.21l-3.95,2.28a.24.24,0,0,1-.12,0Zm-3.46-2.52,3.46,2,3.46-2-3.46-2Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5973",
    "data-name": "Path 5973",
    d: "M177.86,197.2a.27.27,0,0,1-.12,0l-4-2.28a.24.24,0,0,1-.12-.21.27.27,0,0,1,.12-.21l4-2.28a.25.25,0,0,1,.24,0l4,2.28a.27.27,0,0,1,.12.21.24.24,0,0,1-.12.21l-4,2.28A.24.24,0,0,1,177.86,197.2Zm-3.46-2.52,3.46,2,3.46-2-3.46-2Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5974",
    "data-name": "Path 5974",
    d: "M187.69,182.68a.53.53,0,0,1-.24-.06l-11.84-6.83a.5.5,0,0,1-.18-.67.49.49,0,0,1,.67-.17l11.83,6.83a.48.48,0,0,1-.24.9Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5975",
    "data-name": "Path 5975",
    d: "M179.83,187.2a.55.55,0,0,1-.24-.07l-11.83-6.83a.49.49,0,0,1,.48-.85l11.84,6.84a.48.48,0,0,1,.17.66.47.47,0,0,1-.42.25Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5976",
    "data-name": "Path 5976",
    d: "M172,191.7a.54.54,0,0,1-.25-.06l-11.83-6.83a.5.5,0,0,1-.18-.67.48.48,0,0,1,.66-.17l11.84,6.83a.49.49,0,0,1,.18.66.48.48,0,0,1-.42.24Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5977",
    "data-name": "Path 5977",
    d: "M183.22,75.99l67.08,38.72-3.95,2.28L179.28,78.26Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5978",
    "data-name": "Path 5978",
    d: "M183.22,75.99l67.08,38.72-3.95,2.28L179.28,78.26Z",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5979",
    "data-name": "Path 5979",
    d: "M179.28,78.26v77.46l67.07,38.72V116.99Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5980",
    "data-name": "Path 5980",
    d: "M179.28,78.26v77.46l67.07,38.72V116.99Z",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5981",
    "data-name": "Path 5981",
    d: "M250.3,114.71l-15.8,9.12A86.79,86.79,0,0,0,191.12,199v31.91l3.94,2.27L254.24,199V117Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5982",
    "data-name": "Path 5982",
    d: "M250.3,114.71l-15.8,9.12A86.79,86.79,0,0,0,191.12,199v31.91l3.94,2.27L254.24,199V117Z",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5983",
    "data-name": "Path 5983",
    d: "M197.53,166.25,254.24,199h0V117l-3.94-2.28-15.8,9.12a86.77,86.77,0,0,0-36.97,42.41Z",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5984",
    "data-name": "Path 5984",
    d: "M195.06,233.16V201.25a86.759,86.759,0,0,1,43.388-75.139L254.24,117v82Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5985",
    "data-name": "Path 5985",
    d: "M195.06,233.16V201.25a86.759,86.759,0,0,1,43.388-75.139L254.24,117v82Z",
    fill: "#fff",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5986",
    "data-name": "Path 5986",
    d: "M220.92,166.8l-1.79,4.6V174l-.27.16v-2.63l-1.8-2.52.34-.19,1.3,1.87.3.47.28-.8,1.31-3.38Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5987",
    "data-name": "Path 5987",
    d: "M223.24,171.73c-1.33.76-2,0-2-2a4.9,4.9,0,0,1,2-4.38c1.33-.76,2,.11,2,2a4.8,4.8,0,0,1-2,4.38Zm0-6a4.37,4.37,0,0,0-1.76,3.89c0,1.52.5,2.52,1.76,1.78a4.25,4.25,0,0,0,1.76-3.81c0-1.51-.48-2.59-1.76-1.87Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5988",
    "data-name": "Path 5988",
    d: "M229.72,161.73v3.36c0,1.92-.58,3.23-1.82,3.95s-1.83.08-1.83-1.84v-3.37l.26-.15v3.4c0,1.53.44,2.28,1.57,1.63a3.65,3.65,0,0,0,1.56-3.44v-3.39Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5989",
    "data-name": "Path 5989",
    d: "M234.34,165.24l-.3.18-.56-1.3c-.25-.6-.63-.73-1.29-.35l-1.23.71h0v2.67l-.26.15v-6.18l1.89-1.09c.8-.46,1.41-.26,1.41.92a3,3,0,0,1-1,2.25h0a.826.826,0,0,1,.74.59Zm-1.73-4.86-1.66,1h0v2.79l1.6-.92a2.46,2.46,0,0,0,1.2-2.1C233.75,160.13,233.25,160,232.61,160.38Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5990",
    "data-name": "Path 5990",
    d: "M209.09,197.54l-3.73-11.76,2.85-1.64,1.61,5.67c.64,2.23.9,3.16.91,3.21h.05c0-.07.26-1.29.89-4.19l1.63-7.6,2.71-1.57-3.73,16.07Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5991",
    "data-name": "Path 5991",
    d: "M221.64,176.1c3.2-1.84,5.51-.19,5.51,4.06s-2.31,8.57-5.51,10.41-5.5.2-5.5-4S218.45,178,221.64,176.1Zm0,11.31a6.78,6.78,0,0,0,3-5.79c0-2.51-1.26-3.37-3-2.38a6.8,6.8,0,0,0-3,5.82C218.66,187.54,219.91,188.41,221.64,187.41Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5992",
    "data-name": "Path 5992",
    d: "M233.36,172.72v10.81l-2.5,1.45V174.16l-3.2,1.85v-3.1l8.89-5.14v3.11Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5993",
    "data-name": "Path 5993",
    d: "M237.85,167l7.6-4.39v3.1l-5.1,2.94v2.39l3.76-2.17v2.78l-3.76,2.17v2.54l5.18-3v3.11l-7.68,4.43Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5994",
    "data-name": "Path 5994",
    d: "M215.93,204.15l-.25.14v-5.4h0l-.32,1.24-1.53,5.31h0l-1.54-3.56-.32-.85h0v5.42l-.26.14v-6.18l.24-.13,1.65,3.81.24.61h0l.23-.88,1.66-5.72.23-.14Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5995",
    "data-name": "Path 5995",
    d: "M220.74,201.37l-.29.17-.53-1.33h0l-2.6,1.5h0l-.52,1.93-.29.17,2-7.33.23-.14Zm-.91-1.46h0l-1-2.61-.12-.47h0l-.14.61-1,3.8v.06Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5996",
    "data-name": "Path 5996",
    d: "M224,193.63l-1.68,1h0v5.81l-.26.15v-5.82h0l-1.68,1v-.32L224,193.3Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5997",
    "data-name": "Path 5997",
    d: "M227.82,191.43l-1.68,1h0v5.81l-.26.15v-5.86l-1.67,1v-.33l3.58-2.07Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5998",
    "data-name": "Path 5998",
    d: "M231.57,195.12l-3.12,1.8v-6.18l3.12-1.8v.33l-2.89,1.66h0v2.57l2.61-1.51v.33l-2.61,1.51h0v2.58l2.89-1.67Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5999",
    "data-name": "Path 5999",
    d: "M236.1,192.5l-.3.18-.56-1.3c-.25-.6-.63-.73-1.29-.35l-1.23.71h0v2.67l-.26.15v-6.18l1.89-1.09c.8-.46,1.41-.26,1.41.92a3,3,0,0,1-1,2.25h0a.816.816,0,0,1,.74.59Zm-1.73-4.85-1.66.95h0v2.79l1.6-.92a2.46,2.46,0,0,0,1.2-2.1c0-.98-.51-1.09-1.14-.72Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6000",
    "data-name": "Path 6000",
    d: "M238.19,191.37a1.65,1.65,0,0,1-1.77.14l.21-.4a1.41,1.41,0,0,0,1.55-.06,2.6,2.6,0,0,0,1.45-2.12c0-.56-.32-.85-1-.71l-.85.17c-.84.15-1.29,0-1.29-.8a3.1,3.1,0,0,1,1.69-2.53,1.39,1.39,0,0,1,1.55-.1l-.2.39a1.17,1.17,0,0,0-1.34,0,2.55,2.55,0,0,0-1.43,2c0,.66.46.69,1.19.55l.78-.15c.88-.16,1.2.24,1.2.93A3.1,3.1,0,0,1,238.19,191.37Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6001",
    "data-name": "Path 6001",
    d: "M240.05,155.54l.75,1.59,1.68-.64-1.22,2.27.29,2.06-1.5-.18-1.5,1.91.29-2.39-1.21-.87L239.3,158Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6002",
    "data-name": "Path 6002",
    d: "M211.2,172.2l-.75,2.46-1.68,1.29,1.21.87-.28,2.39,1.5-1.91,1.49.18-.28-2.06,1.21-2.27-1.67.64Z",
    fill: "#fd0113"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-54",
    transform: "translate(710 603.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--stand--inject-54-2",
    "data-name": "freepik--stand--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6003",
    "data-name": "Path 6003",
    d: "M335.42,341.29,297.03,458.15l-3.78,2.19,38.39-116.87Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6004",
    "data-name": "Path 6004",
    d: "M293.25,460.34l-1.87-1.08L329.76,342.4l1.88,1.07Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6005",
    "data-name": "Path 6005",
    d: "M346.22,429.75l-1.87-1.07L306.52,356.6l1.88,1.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6006",
    "data-name": "Path 6006",
    d: "M312.18,355.49l37.83,72.08-3.78,2.18L308.4,357.67Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6007",
    "data-name": "Path 6007",
    d: "M282.46,310.71,244.07,427.57l-3.78,2.18,38.39-116.86Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6008",
    "data-name": "Path 6008",
    d: "M240.29,429.75l-1.87-1.07,38.39-116.87,1.87,1.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6009",
    "data-name": "Path 6009",
    d: "M293.26,399.17l-1.87-1.08-37.83-72.08,1.88,1.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6010",
    "data-name": "Path 6010",
    d: "M259.22,324.9l37.83,72.08-3.79,2.19-37.82-72.08Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6011",
    "data-name": "Path 6011",
    d: "M289.48,370.78l-60.54-34.95,64.32-37.14,60.55,34.95Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6012",
    "data-name": "Path 6012",
    d: "M289.48,375.15v-4.37l64.33-37.14v4.37Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6013",
    "data-name": "Path 6013",
    d: "M289.48,375.15v-4.37l-60.54-34.95.02,4.35Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-54-2",
    "data-name": "freepik--box--inject-54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-54-3",
    "data-name": "freepik--box--inject-54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-54-4",
    "data-name": "freepik--box--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6014",
    "data-name": "Path 6014",
    d: "M289.51,366.41V313.99l-51.56-29.67v52.42Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6015",
    "data-name": "Path 6015",
    d: "M289.51,313.99l55.3-31.95v52.43l-55.3,31.94Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6016",
    "data-name": "Path 6016",
    d: "M289.51,313.99l55.3-31.95v52.43l-55.3,31.94Z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6017",
    "data-name": "Path 6017",
    d: "M289.51,313.99,236.5,283.48l56.75-32.79,53,30.51Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6018",
    "data-name": "Path 6018",
    d: "M289.51,313.99,236.5,283.48l56.75-32.79,53,30.51Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6019",
    "data-name": "Path 6019",
    d: "M289.51,313.99v9.36l-53.01-30.5v-9.37Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6020",
    "data-name": "Path 6020",
    d: "M346.25,281.2l-56.74,32.79v9.36l56.74-32.78Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6021",
    "data-name": "Path 6021",
    d: "M346.25,281.2l-56.74,32.79v9.36l56.74-32.78Z",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M238,293.68v2.06l51.56,29.67v-2.06Zm106.86-2.28-55.3,32v2.06l55.3-32Z",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6023",
    "data-name": "Path 6023",
    d: "M274.34,287.77l7.57,4.37,26.49-15.3-7.57-4.36Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6024",
    "data-name": "Path 6024",
    d: "M306.51,277.94l1.89-1.1-7.57-4.36.01,2.2Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6025",
    "data-name": "Path 6025",
    d: "M276.24,288.86l24.59-14.2v-2.18l-26.49,15.29Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6026",
    "data-name": "Path 6026",
    d: "M301.3,344.33l-3.57-11.28,2.73-1.57,1.54,5.43c.62,2.14.86,3,.87,3.08h.05c0-.07.25-1.24.85-4l1.56-7.29,2.6-1.5-3.57,15.41Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6027",
    "data-name": "Path 6027",
    d: "M313.34,323.77c3.06-1.76,5.27-.18,5.27,3.9s-2.21,8.21-5.27,10-5.28.18-5.28-3.89S310.28,325.54,313.34,323.77Zm0,10.85a6.51,6.51,0,0,0,2.86-5.56c0-2.4-1.2-3.23-2.86-2.28a6.52,6.52,0,0,0-2.86,5.58C310.48,334.74,311.68,335.58,313.34,334.62Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6028",
    "data-name": "Path 6028",
    d: "M324.58,320.52v10.37l-2.41,1.39V321.91l-3.05,1.77v-3l8.51-4.92v3Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6029",
    "data-name": "Path 6029",
    d: "M328.88,315.07l7.29-4.21v3l-4.89,2.82v2.29l3.6-2.08v2.67l-3.6,2.08v2.44l5-2.87v3l-7.36,4.25Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Vote--inject-54",
    d: "M307.53,273.72l-2.38,4.96-23.24,13.46-4.85-2.8,13.02-27.49Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-54",
    transform: "translate(710 603.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6030",
    "data-name": "Path 6030",
    d: "M427,353.41c.46,2.26,1.31,4.87,2,9.48s-.38,4.8,2.94,16.36c2,6.93,1.63,9.69-3,15.54-5,6.27-10.19,5-13.59-1.94-2.9-5.93-2.73-8.69-2.74-14.84s-.07-7.94-.38-12.82c-.27-4.3.12-7.24-.17-10.53Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6031",
    "data-name": "Path 6031",
    d: "M428.54,370.26c-.93-6-1.15-12.13-1.49-16.16-.76-9,1.25-26.85-.16-40.42l-25.11-2.29c.84,5.29,7.78,29.21,10.3,43.65,0,0,1,19.6,2.37,28.23a1.84,1.84,0,0,0,2.55,1.28,18.08,18.08,0,0,1,11.37-.69,1.79,1.79,0,0,0,2.42-1.58C430.74,379.09,429.24,374.73,428.54,370.26Z",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6032",
    "data-name": "Path 6032",
    d: "M356.5,306.54c.93,18.5,1.12,32.61.92,40.58a31,31,0,0,1-2.19,11.51c-1.33,3.38-3.64,8.26-5.56,10.41,0,0-6.19,6.63-5,7.25s13.95,1.41,19,0,7-5.66,8.92-13.41,3.64-19.1,3.64-19.1a5.17,5.17,0,0,1-.49-1.33c-.61-2.27,1.81-13.63,2.47-19.28Z",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6033",
    "data-name": "Path 6033",
    d: "M380.77,355.2c-.2,1.92-1.65,4.19-2.14,7.19a52.369,52.369,0,0,0-.7,10.35c.11,4.24.12,4.84.12,4.84h-1.31s-.16-6.12-.22-8.81-1.36-5.05-2.65-5.31C373.87,363.49,374.41,355.36,380.77,355.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6034",
    "data-name": "Path 6034",
    d: "M376.06,342.73c.76,2.17,2.72,5,3.85,7.1a10,10,0,0,1,1.21,3.91,5.33,5.33,0,0,1-1.75,3.87c-1.05,1-1.81,1.83-3.07,3-2.63,2.42-3.73,4.55-5.48,10.16-1,3.34-2.71,6.37-5.67,8-2.31,1.26-8.65,3.4-16.44,3.07-6.47-.27-9-3.09-6.49-5.52s6.7-6.74,7.45-7.25a18.47,18.47,0,0,1,6.86,1.35c3.58,1.64,4.68,3.77,8.52,2,3.48-1.64,5.32-7.63,5.62-17.16C371,344.81,376.06,342.73,376.06,342.73Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6035",
    "data-name": "Path 6035",
    d: "M409.48,180.84c.45,2.36.95,4.56,1.81,5.73,5.24,7.16,10.59,15.82,11.63,29.22,2.52,32.33,2.63,63.55,2.63,63.55.26,2.85,3.68,9,3.25,26.23-.33,13-1.28,32.87-1.28,32.87s-11.42,4.64-19.54,1.63c-3.35-12.36-8.71-41.77-12-55.93-3.49-14.91-5.89-32.91-5.89-32.91l-7.17,28a78.691,78.691,0,0,1,.84,19.69c-.92,8.69-6.5,34.73-6.5,34.73s-13.56,2.91-20.57-1.87c0,0-1.7-43.27-1.83-52.82s-1.62-62.18,4.07-87.19c.26-1.16,1.05-9.07,1.05-9.07C366.83,188.27,400.42,187.05,409.48,180.84Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6036",
    "data-name": "Path 6036",
    d: "M427.74,333.65c-3.51,3.27-16.73,4.32-21,2.1l1.71,7a21.26,21.26,0,0,0,10.31,1.36c6.21-.61,8.77-3.38,8.77-3.38Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6037",
    "data-name": "Path 6037",
    d: "M378.22,329.33c-3.66,1.26-17.84.4-21.88-2l.25,5.8a41.121,41.121,0,0,0,11.69,3.08c6.18.58,8.82-1.18,8.82-1.18Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6038",
    "data-name": "Path 6038",
    d: "M390.06,251.23l-4.43-31.95a20.22,20.22,0,0,1-16.26-7.58s-.16,8,13,11.51l5.2,29.44-4.71,26.56Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6039",
    "data-name": "Path 6039",
    d: "M330.15,159.8c-3.71-2.79-6.53-4.87-10.82-11.72a23.648,23.648,0,0,0-4.16-4.35,17.15,17.15,0,0,1-3.61-4.94c-.39-.93-2.76.07-2.3,3.29.35,2.39,1.8,4.57,2.38,5.93-1.26,0-3.28-.17-6,0s-8.17-.12-7.17,3c.22.7.79,1.29.81,2a5.149,5.149,0,0,1-.17,1,3.69,3.69,0,0,0,1.31,3.54,2.11,2.11,0,0,1,.65.61c.28.54.07,1.2.19,1.77a3.7,3.7,0,0,0,.95,1.73c.67.72.89.47,1.56,1.19.44.47.53,1.51,1.56,2.2.77.51,2.62.57,4.59.54s3.09.62,5.71.54c2.06-.06,4,1.1,7.43,4.62,7.68,7.32,8.66,9.71,15.55,15.3a22.461,22.461,0,0,0,1.9,1.41c6.52,4.49,9.1,1,14.25-8.07,6.33-11.15,9.61-17.47,9.61-17.47l10.16-30.29c-6.26.71-13.62,7.79-19.18,15.82-2.61,3.77-13.42,20.37-13.42,20.37C338.25,165.53,333.87,162.59,330.15,159.8Z",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6040",
    "data-name": "Path 6040",
    d: "M308.28,149.86a4.841,4.841,0,0,1,.8.3,2.7,2.7,0,0,1,.72.51h-.08a5.49,5.49,0,0,1,3.67.57,3,3,0,0,1,.74.64,1.44,1.44,0,0,1,.34,1,1.08,1.08,0,0,1-.18.54,1,1,0,0,1-.51.3c-.32.07-.61.11-.91.17-.59.12-1.17.32-1.78.46a6.29,6.29,0,0,1-1.88.14,14.811,14.811,0,0,1-3.63-.73,12.3,12.3,0,0,0,1.82.28c.61.07,1.21.14,1.82.15A7.531,7.531,0,0,0,311,154c.59-.14,1.17-.35,1.78-.49.31-.07.63-.12.9-.19s.35-.17.39-.47a1.534,1.534,0,0,0-.88-1.28,5.67,5.67,0,0,0-3.45-.71h-.05a2.309,2.309,0,0,0-.63-.52,5.342,5.342,0,0,0-.78-.48Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6041",
    "data-name": "Path 6041",
    d: "M312.56,153.72a1.27,1.27,0,0,1,1.45.49,1.47,1.47,0,0,1-.06,1.63,5.28,5.28,0,0,1-2.33,2.25,4.67,4.67,0,0,1-1.64.2q-.8,0-1.59-.06c-1.06-.07-2.11-.14-3.17-.26,1.06-.05,2.12-.06,3.18-.07a10.39,10.39,0,0,0,3.08-.2,4.25,4.25,0,0,0,1.24-.84,8.078,8.078,0,0,0,1-1.18,1.25,1.25,0,0,0,.15-1.37,1.19,1.19,0,0,0-1.31-.59Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6042",
    "data-name": "Path 6042",
    d: "M312.1,157.6a1.78,1.78,0,0,1,1.45,0,.93.93,0,0,1,.48.62,2.25,2.25,0,0,1,0,.78,3,3,0,0,1-.85,1.24,3.32,3.32,0,0,1-1.22.91,5.491,5.491,0,0,1-1.49.08,13.638,13.638,0,0,0-1.4.16c-.94.15-1.89.31-2.84.44.92-.3,1.84-.54,2.78-.75a8.6,8.6,0,0,1,1.45-.23,5.38,5.38,0,0,0,1.37-.1,3,3,0,0,0,1.08-.77,3.16,3.16,0,0,0,.81-1.06,1.749,1.749,0,0,0,0-.65.68.68,0,0,0-.33-.5,1.75,1.75,0,0,0-1.29-.17Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6043",
    "data-name": "Path 6043",
    d: "M312.3,160.74a.77.77,0,0,1,.44.43,1.26,1.26,0,0,1,.07.64,4.828,4.828,0,0,1-.41,1.14,5.692,5.692,0,0,1-.33.52,1.49,1.49,0,0,1-.47.43,4.78,4.78,0,0,1-1.07.51l.88-.77a1.822,1.822,0,0,0,.35-.39,4.669,4.669,0,0,0,.27-.49,6.546,6.546,0,0,0,.46-1,.91.91,0,0,0-.19-1.02Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6044",
    "data-name": "Path 6044",
    d: "M314.27,152.83a6.72,6.72,0,0,0,5.94,7.29,7.75,7.75,0,0,1-3.7-.81,6.66,6.66,0,0,1-2.43-1.93l-.19.8c-.25-.42-.37-.78-1.51-.67a8.331,8.331,0,0,0,1.34-1.6c.34-.66.83-1.7-.57-2.32a3.36,3.36,0,0,0,.85-.22.44.44,0,0,0,.27-.54Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6045",
    "data-name": "Path 6045",
    d: "M375.38,130.76c-8.86,1.62-12,1.69-21.14,16.49-5.63,9.09-12.47,20.18-12.47,20.18l-6.56-4c1.22,1.23,3.61,7.56,2,11.46a11.2,11.2,0,0,1-5.19,5.53,71.912,71.912,0,0,0,7.19,6.55c3.56,2.71,5.45,3.12,7.61,2.48s4.27-3,9.51-9.21c5.39-6.39,11.7-15.8,11.7-15.8Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6046",
    "data-name": "Path 6046",
    d: "M375.38,130.76c-8.86,1.62-12,1.69-21.14,16.49-5.63,9.09-12.47,20.18-12.47,20.18l-6.56-4c1.22,1.23,3.61,7.56,2,11.46a11.2,11.2,0,0,1-5.19,5.53,71.912,71.912,0,0,0,7.19,6.55c3.56,2.71,5.45,3.12,7.61,2.48s4.27-3,9.51-9.21c5.39-6.39,11.7-15.8,11.7-15.8Z",
    fill: "#fff",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6047",
    "data-name": "Path 6047",
    d: "M341.77,167.43c3.49,2.13,6.84,6.65,7.43,9.32a13.26,13.26,0,0,0-6.27-11.2Z",
    fill: "#fd0113",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6048",
    "data-name": "Path 6048",
    d: "M335.28,183.48a9.67,9.67,0,0,0,1.65-1.1,10.73,10.73,0,0,0,2.6-3,11.71,11.71,0,0,0,1.38-7.4c0-.13.12-.13.15,0a10.73,10.73,0,0,1-1.18,8,11.52,11.52,0,0,1-2.77,3.13,12,12,0,0,1-1.42.94l-.49-.44Z",
    fill: "#fd0113",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Tshirt--inject-54",
    d: "M394.81,127.15l14.16,4.4c2.43.83,11.62,6.44,8.41,20.26-1.06,4.58-2.51,11-3.82,17.41-1,4.9,2.67,14.33,5.63,29.35,0,0-12.14,9.66-36.27,6.94-18.41-2.08-25.33-10-25.33-10-.18-14.33,2.86-23.4,4.22-28.86,0,0-2.06-2.57-2.18-8.4-.11-6.11,3.56-11.46,9-18.38a62,62,0,0,1,10-10.24Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6049",
    "data-name": "Path 6049",
    d: "M363.25,109.89c-.61-2-2.91-2.22-3.4-5s1-4.58,3.22-5.8,2.69-3.43,2.24-8,2.81-7.32,6.58-7.88c1.86-.27,4-.08,5.33-1.44a9.241,9.241,0,0,0,1.25-2.13c1.8-3.32,5.14-4.77,9.61-4.74a15.16,15.16,0,0,1,5.86,1.1,15.35,15.35,0,0,1,5.65,3.76c2.45-.39,7.06.14,9.56,2.34a10,10,0,0,1,4.09,6.62c.42,2.71.17,4.25,1.34,5.72,2.38,3,5.35,3,6.7,5.52,1.92,3.6-2.81,6.69-.4,11a6.54,6.54,0,0,1-3.61,9.56c-2.1.8-3.9-.28-6.9.84s-3.12,3.41-6.94,5c-3.12,1.25-5.79-1-8.32-1.33-3.46-.4-2.35.74-5.76-1.45-1.17-.75-1.87-2.09-3.05-2.83-3.74-2.24-5-1-9.5.6-1.18.43-5.1,1.52-7.77-1.44a10.22,10.22,0,0,1-2.32-6.91c-.76,2.5-6.5,2.45-7.08-1.52a2,2,0,0,0,3.62-1.59Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6050",
    "data-name": "Path 6050",
    d: "M400.22,124.1c0-2.28.46-8.08.46-8.08.84,2.14,4.72,2.22,6.62-.42,2.4-3.34,2.39-7.31.76-9.73-1.81-2.68-6.11-2.75-8,1.4-2.84.53-3.91-3.82-1.58-7.81.05-9.53-12.9-6.32-15.51-14.88a14.88,14.88,0,0,0-10.54,7.83c-1,2.12-1.17,3.42-.93,7.71.09,1.67-1.06,3.61-1.39,5.82-1.53,10.13,1.45,14.17,4.77,16.14,1.77,1,4.07,1.73,8.3,2,0,0-.08,1.9-.16,3.16s-.22,1.81-1.74,2c-.52.07-1.1.11-1.1.11s-7,6.46,2.22,8.15c13.76,2.52,19.26-5.87,19.87-8C400.15,129.06,400.12,127.92,400.22,124.1Z",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6051",
    "data-name": "Path 6051",
    d: "M387.28,113l-5.08,1.36a2.58,2.58,0,0,0,3.17,2,2.75,2.75,0,0,0,1.91-3.36Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6052",
    "data-name": "Path 6052",
    d: "M386.91,114.12a2.89,2.89,0,0,0-3,2.11,2.41,2.41,0,0,0,1.46,0,2.71,2.71,0,0,0,1.92-2.1A1.174,1.174,0,0,1,386.91,114.12Z",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6053",
    "data-name": "Path 6053",
    d: "M374.05,97.65l3.73-1.55a1.93,1.93,0,0,0-2.57-1.1,2.12,2.12,0,0,0-1.16,2.65Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6054",
    "data-name": "Path 6054",
    d: "M392.2,98.89,388.58,97a2,2,0,0,1,2.71-.89,2.16,2.16,0,0,1,.91,2.78Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6055",
    "data-name": "Path 6055",
    d: "M383.16,124.06c6.43-.34,13.67-2.61,16-6.1,0,0-.94,3.55-3.55,5.05a25.57,25.57,0,0,1-12.51,3.14Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6056",
    "data-name": "Path 6056",
    d: "M390.06,103.23a1.71,1.71,0,1,1-1.71-1.7,1.71,1.71,0,0,1,1.71,1.7Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6057",
    "data-name": "Path 6057",
    d: "M377.78,102.44a1.7,1.7,0,1,1-.494-1.209,1.71,1.71,0,0,1,.494,1.209Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6058",
    "data-name": "Path 6058",
    d: "M375.79,109.12l5.5,2.33,1.45-10.97Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6059",
    "data-name": "Path 6059",
    d: "M405.08,114.59a1.4,1.4,0,1,1-1.3-1.505,1.4,1.4,0,0,1,1.3,1.505Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6060",
    "data-name": "Path 6060",
    d: "M382.89,128.1c-.66.24-5.08,1.64-7.51,2.66a58.329,58.329,0,0,0-14.26,16.91c-2.54,4.83-3.86,9-4,16.88-.11,6.85-.94,27.2-2.3,38.52.74,2.65,8.14,5.8,8.14,5.8.38-10.18.56-42.08,2.76-52.9,2.61-12.84,14.11-24.57,16.79-26.41Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6061",
    "data-name": "Path 6061",
    d: "M400.23,127.31v2.1c-6.36,16.54-5.11,24.12-4.3,35,1.93,26,5,48.46,5,48.46s18.16.19,24.63-8.56c0,0-5.82-13.14-8-26.41-1.29-7.87,2.38-24,1-35.39-.56-4.76-2.36-9.51-5.93-10.63-2.95-.93-5.51-1.68-5.51-1.68Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-54-2",
    "data-name": "freepik--arm--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6062",
    "data-name": "Path 6062",
    d: "M422.81,218.33c2.88.82,6.55-2.76,7.56-4s-.29-4.2-.9-6.69,0-6.7-3.08-5.52S416.82,211.62,422.81,218.33Z",
    fill: "#9a4a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6063",
    "data-name": "Path 6063",
    d: "M413.21,132.51c9.32,1.94,10.23,1.66,14.63,10.51,5.13,10.3,12.39,27.12,14.22,31s3.6,6.79-1.33,12.84c-4.39,5.39-17.36,20.91-19.29,23.13-1.7,2,.21,7.76,6.06,6.92,0,0-4.45,3.94-6.9,3.5-2.11-.37-7.44-3.62-10.49-10-1.92-4-.31-7.21,2.61-11.71,3.49-5.37,12.13-19.74,12.13-19.74L412,153.29S406.4,139.61,413.21,132.51Z",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6064",
    "data-name": "Path 6064",
    d: "M412.65,131.88c-2.26,2.25-5.85,10.69-.85,22.89L424.39,179l-5.61,9s4,5.21,7.37,7.59a8.22,8.22,0,0,0,6.49,1.51s7.21-8,9.76-11.51,3-4.52-.25-12.4c-3.14-7.6-13.12-30.74-15.26-34.28S422,133,412.65,131.88Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6065",
    "data-name": "Path 6065",
    d: "M412.65,131.88c-2.26,2.25-5.85,10.69-.85,22.89L424.39,179l-5.61,9s4,5.21,7.37,7.59a8.22,8.22,0,0,0,6.49,1.51s7.21-8,9.76-11.51,3-4.52-.25-12.4c-3.14-7.6-13.12-30.74-15.26-34.28S422,133,412.65,131.88Z",
    fill: "#fff",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M427,188.83a23,23,0,0,1-2.65-2.38,21.692,21.692,0,0,1-2.21-2.68c-.11-.16-.24-.39-.34-.56l-.43.68a3.994,3.994,0,0,1,.22.34,24.476,24.476,0,0,0,2.2,2.68,21.82,21.82,0,0,0,2.63,2.36,13.579,13.579,0,0,0,3.23,2c.32.12.34-.32.14-.47C428.83,190.1,427.86,189.52,427,188.83Z",
    fill: "#fd0113",
    opacity: 0.35
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-54",
    transform: "translate(710 603.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-54-2",
    "data-name": "freepik--speech-bubble--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6110",
    "data-name": "Path 6110",
    d: "M309.71,64.17l29.22,16.9c.57.34,1,1.15,1,2.71v35.71c0-.24-.47.57-1.05.89l-4.15,2.36a2.33,2.33,0,0,1-2.09,0l-29.22-16.9a2.31,2.31,0,0,1-1-1.81V68.32a2.28,2.28,0,0,1,1.05-1.8l4.15-2.36A2.36,2.36,0,0,1,309.71,64.17Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6111",
    "data-name": "Path 6111",
    d: "M332.68,122.73a2.36,2.36,0,0,0,2.09,0l4.15-2.36c.58-.32,1.05-1.13,1.05-.89V83.78a3.43,3.43,0,0,0-.33-2l-6.23,3.58c.2.32.31.69.31.13v35.7C333.72,122.74,333.29,123.09,332.68,122.73Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6112",
    "data-name": "Path 6112",
    d: "M302.43,68.13a.6.6,0,0,1,1-.42l29.21,16.91a2,2,0,0,1,.73.78l6.23-3.58a2.08,2.08,0,0,0-.72-.75l-29.21-16.9a2.33,2.33,0,0,0-2.09,0l-4.15,2.36a2.36,2.36,0,0,0-1,1.6Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6113",
    "data-name": "Path 6113",
    d: "M342.83,109.36c.65-.39,5.65-3.2,5.81-3.3a1,1,0,0,0,.2-1.48L340,94.4,333.72,98l9.28,9.9a1,1,0,0,1-.17,1.46Z",
    fill: "#fd0113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6114",
    "data-name": "Path 6114",
    d: "M342.83,109.36c.65-.39,5.65-3.2,5.81-3.3a1,1,0,0,0,.2-1.48L340,94.4,333.72,98l9.28,9.9a1,1,0,0,1-.17,1.46Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6115",
    "data-name": "Path 6115",
    d: "M303.46,67.72l29.22,16.9a2.28,2.28,0,0,1,1,1.8V98l9.32,9.9a.94.94,0,0,1-.6,1.6l-8.69-.64h0v13.27c0,.66-.46.93-1,.6l-29.22-16.9a2.31,2.31,0,0,1-1-1.81V68.32C302.42,67.65,302.89,67.38,303.46,67.72Z",
    fill: "#fd0113"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6116",
    "data-name": "Path 6116",
    d: "M314.71,105.35h-.3a2.26,2.26,0,0,1-1.73-1.27l-3.6-7.58a2.243,2.243,0,1,1,4.06-1.91L315.27,99l10.29-12A2.282,2.282,0,1,1,329,90l-12.55,14.61a2.24,2.24,0,0,1-1.74.74Z",
    fill: "#fafafa"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteSuccess);
export default __webpack_public_path__ + "static/media/vote_success.15f689ac16cdff6ea6494be7e1eac81f.svg";
export { ForwardRef as ReactComponent };